// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { promotionCodeFormStyles } from "@guestsupply/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import Check from "@guestsupply/XDL/Icons/Check";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

promotionCodeFormStyles.gridContainer = {
    gap: 8,
};

promotionCodeFormStyles.promoTextFieldAndApplyButtonGridItem = {
    width: 12,
    css: css`
        display: flex;
        gap: 8px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};

promotionCodeFormStyles.promotionCodeGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        margin-top: 10px;
    `,
};

promotionCodeFormStyles.applyPromotionGridItem = {
    width: 3,
    css: css`
        width: 100%;
        display: flex;
    `,
};

promotionCodeFormStyles.applyButton = {
    variant: "primary",
    css: css`
        margin-left: 4px;
        margin-top: 24px;
        ${xScreen("lte", "md")} {
            margin-top: 0;
        }
    `,
};

promotionCodeFormStyles.promotionAppliedGridItem = {
    width: 12,
    css: css`
        gap: 8px;
        align-items: center;
    `,
};

promotionCodeFormStyles.successAppliedPromoIcon = {
    src: Check,
    size: 12,
    color: "success",
};

promotionCodeFormStyles.applySuccessText = {
    color: "success",
    size: 12,
    lineHeight: "14px",
};
